"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var FooterSection = function FooterSection(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_indexModule.default.FooterSection, className)
  }, children);
};

FooterSection.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string
};
var _default = FooterSection;
exports.default = _default;